import React from 'react';
import { useMutation } from 'react-query';
import { makeRequest } from '@crx-dev/hss-react-infrastructure';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { Form, getFieldProps, Inputs, Label, Modal, ModalFormFooter } from '@crx-dev/hss-react-components';
import { useUserInfo } from '../../../../Infrastructure/auth/UseUserInfo';

interface BulkStockCheckFormProps {
    registersIds: string[];
    onCancel: () => void;
}

function BulkStockCheckForm({ registersIds, onCancel }: BulkStockCheckFormProps) {
    const userInfo = useUserInfo();

    const mutation = useMutation<unknown, unknown, any>(item =>
        makeRequest({
            method: 'POST',
            path: `/api/v1/controldrugregister/bulkstockcheck`,
            data: { ...item, user: userInfo.name }
        })
    );

    const formik = useFormik({
        initialValues: {
            dateEntry: new Date(Date.now()),
            checkedBy: userInfo.name,
            registersIds: registersIds
        },
        validationSchema: yup.object().shape({
            checkedBy: yup.string().required('Required')
        }),
        onSubmit: async values => {
            await mutation.mutateAsync(values);
            onCancel();
        }
    });

    return (
        <Modal onCancel={onCancel} open={true} title="Confirm Bulk Stock Check">
            <Form onSubmit={formik.handleSubmit}>
                <br />
                <Label label="Entry Date" htmlFor="dateEntry" />
                <Inputs.DatePicker {...getFieldProps(formik, 'dateEntry')} disabled />
                <Label label="Checked By" htmlFor="checkedBy" />
                <Inputs.Text {...getFieldProps(formik, 'checkedBy')} />

                <ModalFormFooter
                    isSubmitting={mutation.isLoading}
                    onCancel={onCancel}
                    submitButtonLabel="Confirm Stock Check"
                    submitError={mutation.isError}
                />
            </Form>
        </Modal>
    );
}

export default BulkStockCheckForm;
